import React from 'react'
import { HiOutlineInformationCircle } from 'react-icons/hi2'
import './DevelopmentBanner.css'

const DevelopmentBanner = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-orange-500 via-amber-500 to-orange-500 text-white py-1 shadow-lg overflow-hidden" style={{ height: '30px' }}>
      <div className="ticker-wrapper">
        <div className="ticker-content">
          {/* Repeat the message multiple times for seamless loop */}
          {[...Array(10)].map((_, index) => (
            <span key={index} className="inline-flex items-center gap-1.5 mx-6">
              <HiOutlineInformationCircle className="w-4 h-4 flex-shrink-0" />
              <span className="font-medium whitespace-nowrap text-sm">
                ⚠️ OVACS is still under development - New version coming soon! | All data will be deleted before final version upload ⚠️
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}

export default DevelopmentBanner

